enum PriceType {
  FLOAT = 'FLOAT',
  FIXED = 'FIXED',
  WARRANTY_SOLUTION = 'WARRANTY_SOLUTION'
}

export default PriceType;